export const Authendpoint = {
  Login: "admin/login",
  logout: "admin/log-out",
};
export const Globalendpoints = {
  dashboardCount: "admin/fetch-dashboard-count",
  addBankDetail: "admin/add-bank-details",
  updateBankDetail: "admin/update-bank-details",
  fetchBankDetail: "admin/fetch-bank-details",
  getPaymentSetting: "admin/get-payment-setting",
  updatePaymentSetting: "admin/update-payment-setting",
  fetchFundReq: "admin/fetch-fund-request",
  fundReqAction: "admin/update-fund-request",
  fetchWithdrawalReq: "admin/fetch-withdrawal",
  updateWithdrawalReq: "admin/update-withdraw-request",

  //number (matka) game

  numberRooms: "number/admin/rooms-details",
  numberRoomDetail: "number/admin/detail/",
  numberDeclareResult: "number/admin/declare-result/",

  userList: "admin/fetch-user-list",
  updateUser: "admin/update-user-status",
  userBettings: "admin/fetch-user-bettings",
  walletTxn: "admin/fetch-user-wallet-tranx",
  changePassword: "admin/change-password",

  //comissionSetting
  fetchComissionSetting: "admin/fetch-commission-setting",
  updateReferalComm:"admin/update-referal-setting"
};
